module.exports = __webpack_public_path__ + "static/media/icon-tips.fda994f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/icon-tips.png
// module id = 1947
// module chunks = 6